module.exports = __webpack_public_path__ + "static/media/background.197712a1.png";